import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule , getBaseUrl} from './app/app.module';
import { environment } from './environments/environment';
//import * as Sentry from "@sentry/angular";
import {init, browserTracingIntegration } from '@sentry/angular';

init({
  dsn: environment.sentryDns,
  sendClientReports: false,
  integrations: [
    browserTracingIntegration(),
  ],
  tracePropagationTargets: ['traceparent', 'sentry-trace'],
  tracesSampleRate: 1.0,
});

  const providers = [
  { provide: 'BASE_URL', useFactory: getBaseUrl, deps: [] }
];




if (environment.production) {
  // Désactive les console.log() en prod
  if (window) {
    window.console.log = function () { };
    window.console.table = function () { };
    window.console.assert = function () { };
    window.console.clear = function () { };
    window.console.count = function () { };
    window.console.debug = function () { };
    window.console.dir = function () { };
    window.console.error = function () { };
    //window.console.exception = function () { };
    window.console.info = function () { };
    window.console.time = function () { };
    window.console.trace = function () { };
    window.console.warn = function () { };
  }
}

platformBrowserDynamic(providers).bootstrapModule(AppModule)
  .catch(err => console.error(err));
